/* Matmuis homepage – snel toevoegen aan winkelwagen (okt 2026) */
(function () {
  if (window.mmxReady) return;
  window.mmxReady = true;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mmx-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');

    var drawer = document.querySelector('cart-drawer');
    var sections = [];
    try {
      if (drawer && typeof drawer.getSectionsToRender === 'function') {
        sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      }
    } catch (err) {}

    var body = { id: Number(btn.dataset.mmxAdd), quantity: 1 };
    if (sections.length) { body.sections = sections.join(','); body.sections_url = window.location.pathname; }
    var base = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add';
    var cartUrl = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';

    fetch(base + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        btn.classList.remove('is-loading');
        if (!res.ok) {
          btn.textContent = res.j && res.j.description ? res.j.description : 'Niet beschikbaar';
          btn.classList.add('is-disabled');
          return;
        }
        document.dispatchEvent(new CustomEvent('cart:updated'));
        if (drawer && typeof drawer.renderContents === 'function' && res.j.sections) {
          try { drawer.classList.remove('is-empty'); drawer.renderContents(res.j); return; } catch (err) {}
        }
        window.location.href = cartUrl;
      })
      .catch(function () { window.location.href = btn.dataset.url || cartUrl; });
  });
})();
